module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6.3 17.076l-6.96 6.644a1.053 1.053 0 0 1-1.434 0l-7.014-6.7a.94.94 0 0 1 0-1.368l1.434-1.368a1.048 1.048 0 0 1 1.434 0L14 16.97V9.002A1 1 0 0 1 14.998 8h2C17.55 8 18 8.45 18 9.002v8.022l2.836-2.682a1.043 1.043 0 0 1 1.43 0L23.7 15.71a.93.93 0 0 1 0 1.366z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-square-4.js
// module id = 1117
// module chunks = 14